import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsDepartmentType, PmsDepartmentType } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsDepartmentType>
    useData={usePmsDepartmentType}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
